export default "__VITE_ASSET__BrfnceL3__"